import Glider from 'glider-js';
import { MQ } from '../tools/MQ.js';

export const init = () => {
	const jsArticleCarousel = document.querySelectorAll('.js-benefits-carousel');

	Array.from(jsArticleCarousel).forEach((item, index) => {
		if (item.classList.contains('js-benefits-desktop-carousel')) {
			new Glider(item, {
				slidesToShow: 1,
				slidesToScroll: 1,
				scrollLock: true,
				draggable: true,
				dots: item.nextElementSibling,
				arrows: false,
				responsive: [
					{
						breakpoint: 1000,
						settings: {
							dots: false,
							arrows: {
								prev: item.parentElement.querySelector('.js-carousel-prev'),
								next: item.parentElement.querySelector('.js-carousel-next'),
							},
							slidesToShow: 3,
							slidesToScroll: 'auto',
							draggable: false,
						},
					},
				],
			});
		} else if (item.classList.contains('js-benefits-mobile-carousel')) {
			new Glider(item, {
				slidesToShow: 1,
				slidesToScroll: 1,
				scrollLock: true,
				draggable: true,
				dots: item.nextElementSibling,
				arrows: false,
				responsive: [
					{
						breakpoint: 1000,
						settings: {
							dots: false,
							slidesToShow: 3,
							slidesToScroll: 'auto',
							draggable: false,
						},
					},
				],
			});
		} else {
			if (parseInt(item.dataset.items) === 2) {
				if (MQ('mdDown')) {
					new Glider(item, {
						slidesToShow: 1,
						slidesToScroll: 1,
						scrollLock: true,
						draggable: true,
						dots: item.nextElementSibling,
						responsive: [
							{
								breakpoint: 750,
								settings: {
									dots: false,
									slidesToShow: item.dataset.items,
									slidesToScroll: 'auto',
								},
							},
						],
					});
				}
			}

			if (parseInt(item.dataset.items) === 3) {
				if (MQ('lgDown')) {
					new Glider(item, {
						slidesToShow: 1,
						slidesToScroll: 1,
						draggable: true,
						scrollLock: true,
						dots: item.nextElementSibling,
						responsive: [
							{
								breakpoint: 750,
								settings: {
									slidesToShow: 2,
								},
							},
							{
								breakpoint: 1000,
								settings: {
									dots: false,
									slidesToShow: item.dataset.items,
								},
							},
						],
					});
				}
			}
		}
	});
};
